export const movieList = [
  {
    id: "m1",
    type: "movie",
    title: "长夜将尽",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20of%20a%20lone%20detective%20standing%20in%20rainy%20neon%20city%20street%20at%20night%2C%20moody%20dark%20blue%20tones%2C%20dramatic%20lighting%2C%20film%20noir%20aesthetic%2C%20vertical%20poster%20composition%2C%20high%20detail&width=600&height=800&seq=moviecover-01&orientation=portrait",
    year: 2024,
    region: "中国大陆",
    genres: ["剧情", "犯罪", "悬疑"],
    rating: 8.7,
    director: "陈牧远",
    actors: ["张峻", "林澈", "周海涛"],
    summary: "一桩尘封十五年的悬案重新浮出水面，退休刑警在追查真相的过程中，逐渐发现自己也深陷其中。城市的霓虹之下，每个人都藏着不愿示人的秘密。",
    duration: 128,
    status: "已上映",
    episodes: [],
    tags: ["悬疑", "犯罪", "高口碑"],
  },
  {
    id: "m2",
    type: "movie",
    title: "山海之间",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20film%20poster%20of%20a%20young%20woman%20looking%20at%20vast%20misty%20mountains%20and%20sea%2C%20warm%20sunrise%20light%2C%20epic%20landscape%20backdrop%2C%20emotional%20atmosphere%2C%20vertical%20poster%2C%20high%20detail&width=600&height=800&seq=moviecover-02&orientation=portrait",
    year: 2023,
    region: "中国大陆",
    genres: ["剧情", "爱情", "文艺"],
    rating: 8.2,
    director: "苏婉清",
    actors: ["李知夏", "顾沉", "沈棠"],
    summary: "两个在小镇长大的年轻人，带着各自的梦想走向不同的城市。多年后重回故里，他们才发现，山海之间隔着的从来不是距离，而是时间。",
    duration: 118,
    status: "已上映",
    episodes: [],
    tags: ["文艺", "爱情", "治愈"],
  },
  {
    id: "m3",
    type: "movie",
    title: "暗流",
    cover: "https://readdy.ai/api/search-image?query=Suspense%20thriller%20movie%20poster%20of%20a%20man%20in%20suit%20silhouette%20against%20underwater%20dark%20blue%20background%2C%20ominous%20mood%2C%20minimalist%20composition%2C%20vertical%20poster%2C%20cinematic%20detail&width=600&height=800&seq=moviecover-03&orientation=portrait",
    year: 2025,
    region: "中国香港",
    genres: ["犯罪", "动作", "悬疑"],
    rating: 7.9,
    director: "黄志锋",
    actors: ["郑则升", "吴启华", "何美琪"],
    summary: "一笔巨额资金在金融风暴中凭空蒸发，卧底警察与犯罪集团展开了一场没有硝烟的智斗。暗流涌动的资本世界，谁能笑到最后。",
    duration: 134,
    status: "已上映",
    episodes: [],
    tags: ["动作", "港片", "金融"],
  },
  {
    id: "m4",
    type: "movie",
    title: "星海征途",
    cover: "https://readdy.ai/api/search-image?query=Science%20fiction%20space%20movie%20poster%20of%20an%20astronaut%20facing%20a%20giant%20spaceship%20in%20deep%20space%2C%20stars%20and%20nebula%2C%20cool%20teal%20and%20orange%20accents%2C%20epic%20vertical%20composition%2C%20high%20detail&width=600&height=800&seq=moviecover-04&orientation=portrait",
    year: 2025,
    region: "美国",
    genres: ["科幻", "冒险", "动作"],
    rating: 8.9,
    director: "Marcus Vale",
    actors: ["Ethan Cole", "Nora Reed", "Julian Pace"],
    summary: "人类首次跨越虫洞寻找第二家园，一支精英舰队在星际航行中遭遇未知文明的考验。宇宙的尽头，等待他们的是希望还是毁灭。",
    duration: 149,
    status: "已上映",
    episodes: [],
    tags: ["科幻", "太空", "大片"],
  },
  {
    id: "m5",
    type: "movie",
    title: "春日来信",
    cover: "https://readdy.ai/api/search-image?query=Romantic%20drama%20movie%20poster%20of%20a%20young%20couple%20under%20cherry%20blossom%20trees%20in%20spring%2C%20soft%20pink%20and%20green%20tones%2C%20warm%20sunlight%2C%20gentle%20emotional%20atmosphere%2C%20vertical%20poster%2C%20high%20detail&width=600&height=800&seq=moviecover-05&orientation=portrait",
    year: 2023,
    region: "日本",
    genres: ["爱情", "剧情", "治愈"],
    rating: 8.4,
    director: "佐藤健一",
    actors: ["桥本环奈", "山崎贤人", "新垣结衣"],
    summary: "一封迟到了十年的信，牵出一段未曾说出口的青春爱恋。每年春天樱花盛开时，她都会来到那棵树下，等一个或许永远不会来的人。",
    duration: 112,
    status: "已上映",
    episodes: [],
    tags: ["爱情", "日影", "治愈"],
  },
  {
    id: "m6",
    type: "movie",
    title: "荒原猎人",
    cover: "https://readdy.ai/api/search-image?query=Western%20action%20movie%20poster%20of%20a%20rugged%20lone%20hunter%20with%20rifle%20in%20vast%20desert%20canyon%2C%20dusty%20orange%20survival%20tones%2C%20dramatic%20sunset%2C%20vertical%20poster%2C%20cinematic%20high%20detail&width=600&height=800&seq=moviecover-06&orientation=portrait",
    year: 2022,
    region: "美国",
    genres: ["动作", "冒险", "西部"],
    rating: 7.6,
    director: "Harvey Shaw",
    actors: ["Cole Bennett", "Ivy Dalton", "Ray Mercer"],
    summary: "在资源枯竭的末世荒原上，一名孤独的猎人为了守护最后的水源，与掠夺者展开殊死搏斗。生存的法则，从来都是用命换来的。",
    duration: 126,
    status: "已上映",
    episodes: [],
    tags: ["动作", "末日", "硬核"],
  },
  {
    id: "m7",
    type: "movie",
    title: "笑看风云",
    cover: "https://readdy.ai/api/search-image?query=Comedy%20movie%20poster%20of%20a%20cheerful%20man%20in%20colorful%20retro%20suit%20doing%20silly%20pose%2C%20bright%20playful%20yellow%20and%20orange%20background%2C%20fun%20energetic%20mood%2C%20vertical%20poster%2C%20high%20detail&width=600&height=800&seq=moviecover-07&orientation=portrait",
    year: 2024,
    region: "中国大陆",
    genres: ["喜剧", "剧情"],
    rating: 7.4,
    director: "王大鹏",
    actors: ["沈腾飞", "马丽娜", "贾冰洋"],
    summary: "一个中年失意的小人物意外继承了巨额遗产，从此人生天翻地覆。钱能买来一切吗？他用自己的方式给出了答案。",
    duration: 105,
    status: "已上映",
    episodes: [],
    tags: ["喜剧", "合家欢", "爆笑"],
  },
  {
    id: "m8",
    type: "movie",
    title: "冰封之城",
    cover: "https://readdy.ai/api/search-image?query=Disaster%20movie%20poster%20of%20an%20ice%20covered%20frozen%20city%20skyline%20with%20blizzard%2C%20cold%20blue%20and%20white%20tones%2C%20apocalyptic%20atmosphere%2C%20vertical%20poster%2C%20dramatic%20high%20detail&width=600&height=800&seq=moviecover-08&orientation=portrait",
    year: 2025,
    region: "韩国",
    genres: ["灾难", "剧情", "科幻"],
    rating: 8.1,
    director: "金成勋",
    actors: ["李政宰", "孙艺珍", "孔刘"],
    summary: "突如其来的极寒气候将整座城市冰封，一群素不相识的幸存者被困在地铁站内。零下五十度的世界里，人类的信念才是最后的火种。",
    duration: 138,
    status: "已上映",
    episodes: [],
    tags: ["灾难", "韩影", "催泪"],
  },
  {
    id: "m9",
    type: "movie",
    title: "归途列车",
    cover: "https://readdy.ai/api/search-image?query=Road%20drama%20movie%20poster%20of%20a%20vintage%20train%20traveling%20through%20golden%20farmland%20at%20dusk%2C%20nostalgic%20warm%20tones%2C%20lonely%20emotional%20mood%2C%20vertical%20poster%2C%20cinematic%20detail&width=600&height=800&seq=moviecover-09&orientation=portrait",
    year: 2022,
    region: "欧洲",
    genres: ["剧情", "公路", "文艺"],
    rating: 8.0,
    director: "Luca Moretti",
    actors: ["Andrei Novak", "Clara Bell", "Tom Reis"],
    summary: "一位老人乘坐横跨大陆的列车踏上归途，车厢里形形色色的旅客，让他重温了自己一生的悲欢。归途很长，回忆更长。",
    duration: 121,
    status: "已上映",
    episodes: [],
    tags: ["文艺", "公路", "欧洲"],
  },
  {
    id: "m10",
    type: "movie",
    title: "霓虹正义",
    cover: "https://readdy.ai/api/search-image?query=Cyberpunk%20action%20movie%20poster%20of%20a%20female%20agent%20with%20glowing%20neon%20city%20backdrop%2C%20magenta%20and%20cyan%20accents%2C%20futuristic%20tense%20mood%2C%20vertical%20poster%2C%20high%20detail&width=600&height=800&seq=moviecover-10&orientation=portrait",
    year: 2024,
    region: "美国",
    genres: ["科幻", "动作", "犯罪"],
    rating: 7.8,
    director: "Sofia Grant",
    actors: ["Mia Torres", "Derek Liang", "Owen Frost"],
    summary: "在未来的高科技都市，一名女特工奉命追查一连串神秘案件，却发现真相直指她所在的组织。正义或许会迟到，但霓虹不会说谎。",
    duration: 132,
    status: "已上映",
    episodes: [],
    tags: ["科幻", "赛博朋克", "动作"],
  },
  {
    id: "m11",
    type: "movie",
    title: "老屋的灯",
    cover: "https://readdy.ai/api/search-image?query=Family%20drama%20movie%20poster%20of%20an%20old%20countryside%20house%20with%20warm%20light%20in%20the%20window%20at%20night%2C%20nostalgic%20sepia%20and%20amber%20tones%2C%20emotional%20quiet%20mood%2C%20vertical%20poster%2C%20high%20detail&width=600&height=800&seq=moviecover-11&orientation=portrait",
    year: 2023,
    region: "中国大陆",
    genres: ["剧情", "家庭"],
    rating: 8.5,
    director: "田宁",
    actors: ["李文远", "赵秀兰", "孙浩"],
    summary: "为了照顾年迈的母亲，在外打拼多年的儿子回到老家。老屋的灯亮了又灭，两代人之间未说出口的爱，在一顿顿饭里慢慢和解。",
    duration: 116,
    status: "已上映",
    episodes: [],
    tags: ["家庭", "亲情", "催泪"],
  },
  {
    id: "m12",
    type: "movie",
    title: "幻影拳王",
    cover: "https://readdy.ai/api/search-image?query=Sports%20drama%20movie%20poster%20of%20a%20determined%20young%20boxer%20with%20fists%20raised%20in%20dim%20ring%2C%20sweat%20and%20spotlight%2C%20gritty%20golden%20and%20dark%20tones%2C%20vertical%20poster%2C%20high%20detail&width=600&height=800&seq=moviecover-12&orientation=portrait",
    year: 2022,
    region: "中国大陆",
    genres: ["剧情", "运动", "励志"],
    rating: 7.7,
    director: "付强",
    actors: ["刘子轩", "许安然", "潘志远"],
    summary: "一个来自小城的少年怀揣拳击梦想，在无数次倒下与爬起之间，他逐渐明白真正的对手从来不是别人，而是自己。",
    duration: 124,
    status: "已上映",
    episodes: [],
    tags: ["励志", "运动", "热血"],
  },
];